<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';
	import { onMount } from 'svelte';

	interface Props {
		config: BrandConfig;
	}

	let { config }: Props = $props();
	let logoExists = $state(false);

	// Check if logo exists by attempting to load it
	onMount(async () => {
		try {
			const response = await fetch(config.logo, { method: 'HEAD' });
			logoExists = response.ok;
		} catch {
			logoExists = false;
		}
	});
</script>

<a href="/" style="
	display: flex;
	align-items: center;
	gap: 1rem;
	text-decoration: none;
	color: inherit;
	transition: opacity 0.2s ease;
">
	{#if logoExists}
		<img
			src={config.logo}
			alt="{config.displayName} logo"
			style="height: 40px; width: auto;"
		/>
	{/if}
	<h1 style="margin: 0; font-size: 1.5rem; font-weight: bold;">
		{config.displayName}
	</h1>
</a>

<style>
	a:hover {
		opacity: 0.8;
	}
</style>
